import React from 'react';
import { useSelector } from 'react-redux';
import { IRootState } from 'src/reducers';

export const AppContext = React.createContext(undefined);

const AppContextProvider: React.FC = (props) => {
    const appContext = useSelector((state: IRootState) => state.appContext);

    return <AppContext.Provider value={appContext}>{props.children}</AppContext.Provider>;
};

export default AppContextProvider;



// WEBPACK FOOTER //
// ./src/providers/AppContextProvider.tsx